export default __webpack_public_path__ + "static/media/progressbar-loop-icon.d003f4dc.svg";